import { useScrollAnimation } from "@/hooks/useScrollAnimation";

const stats = [
  {
    icon: "ri-heart-pulse-line",
    value: "50K+",
    label: "People Reached",
    description: "Through health outreach programs across Cameroon",
  },
  {
    icon: "ri-school-line",
    value: "12",
    label: "Schools Supported",
    description: "Renovated and equipped with learning materials",
  },
  {
    icon: "ri-group-line",
    value: "200+",
    label: "Volunteers",
    description: "Dedicated professionals serving communities",
  },
  {
    icon: "ri-calendar-check-line",
    value: "10+",
    label: "Years of Service",
    description: "Committed to sustainable community development",
  },
];

export default function StatsSection() {
  useScrollAnimation();

  return (
    <section className="bg-primary py-16 md:py-20 px-4 md:px-8">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {stats.map((stat, idx) => (
            <div
              key={idx}
              className={`animate-on-scroll animate-on-scroll-delay-${idx} flex flex-col items-center text-center text-white`}
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center bg-white/15 rounded-2xl mb-4 backdrop-blur-sm">
                <i className={`${stat.icon} text-2xl md:text-3xl text-white`}></i>
              </div>
              <span className="text-3xl md:text-4xl font-saria font-bold mb-1">
                {stat.value}
              </span>
              <span className="text-sm md:text-base font-inter font-semibold mb-1">
                {stat.label}
              </span>
              <span className="text-xs md:text-sm text-white/70 leading-relaxed max-w-[200px]">
                {stat.description}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}